<template>
    <div class="frame" v-show="this.$store.getters.changeLoad">
        <div class="box">
            <div class="containerImg">
                <img :src="icon" alt="">
            </div>
            <div class="containerLoad">
                <!-- <div :class="[{loading: this.$store.getters.changeLoad}]"></div> -->
                <div class="loading"></div>
            </div>
            <h2>Carregando...</h2>
        </div>
    </div>

</template>

<script>
import icon from "../assets/image/iconCar.svg";
export default {
    data: () => {
    return {
        icon
    };
}
}
</script>

<style scoped>
.box{
    min-width: 10rem;
    height: 25rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: .5rem;

    
    
}
@keyframes car{
    from{
        transform: translateY(-1px);
    }
    to{
        transform: translateY(1px);
    }
}
.containerImg{
    width: 5rem;
    height: 5rem;
    

    animation: car .5s linear alternate infinite;
    transform-origin: center;
    transform-box: fill-box;

    display: flex;
}
.containerImg img{
    width: 100%;
}
.frame{
    right: 0;
    height: 100vh;
    width: 100%;
    background: rgba(216, 216, 216, 0.205);
    backdrop-filter: blur(5px);
    position: fixed;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
    .containerLoad{
        width: 100%;
        height: .4rem;
    }
    .loading{
        height: 100%;

        animation: loading 1s infinite ease-in-out;
        transform-origin: center;
        transform-box: fill-box;
    }
    @keyframes loading{
        0%{
            width: 0%;
            margin-left: 0%;
        }
        50%{
            width: 100%;
            margin-left: 0%;
            background: var(--colorPrimary);
        }
        100%{
            width: 0%;
            margin-left: 100%;
            
        }
    }
    @media only screen and (max-width: 600px) {
        .containerLoad{
            top: 3rem;
        }
    }
</style>